import { useRef } from "react";
import { useFrame } from "@react-three/fiber";

// Stylized holographic wireframe humanoid — thematically a "digital AI avatar",
// procedural (no external rig needed). Legs/arms swing while moving.
export default function CharacterAvatar({ movingRef }) {
  const leftLeg = useRef();
  const rightLeg = useRef();
  const leftArm = useRef();
  const rightArm = useRef();
  const bodyRef = useRef();

  useFrame(({ clock }) => {
    const t = clock.elapsedTime;
    const isMoving = movingRef.current;
    const swing = isMoving ? Math.sin(t * 9) * 0.6 : 0;
    if (leftLeg.current) leftLeg.current.rotation.x = swing;
    if (rightLeg.current) rightLeg.current.rotation.x = -swing;
    if (leftArm.current) leftArm.current.rotation.x = -swing * 0.8;
    if (rightArm.current) rightArm.current.rotation.x = swing * 0.8;
    if (bodyRef.current) {
      bodyRef.current.position.y = 1.15 + (isMoving ? Math.abs(Math.sin(t * 9)) * 0.06 : Math.sin(t * 1.5) * 0.02);
    }
  });

  const mat = { color: "#01FFFF", toneMapped: false };

  return (
    <group>
      <group ref={bodyRef} position={[0, 1.15, 0]}>
        <mesh>
          <capsuleGeometry args={[0.28, 0.6, 4, 8]} />
          <meshBasicMaterial {...mat} wireframe />
        </mesh>
        <mesh position={[0, 0.62, 0]}>
          <sphereGeometry args={[0.22, 12, 12]} />
          <meshBasicMaterial color="#FF007F" toneMapped={false} wireframe />
        </mesh>
        <group ref={leftArm} position={[-0.36, 0.15, 0]}>
          <mesh position={[0, -0.28, 0]}>
            <boxGeometry args={[0.12, 0.55, 0.12]} />
            <meshBasicMaterial {...mat} wireframe />
          </mesh>
        </group>
        <group ref={rightArm} position={[0.36, 0.15, 0]}>
          <mesh position={[0, -0.28, 0]}>
            <boxGeometry args={[0.12, 0.55, 0.12]} />
            <meshBasicMaterial {...mat} wireframe />
          </mesh>
        </group>
      </group>
      <group ref={leftLeg} position={[-0.14, 0.55, 0]}>
        <mesh position={[0, -0.27, 0]}>
          <boxGeometry args={[0.14, 0.55, 0.14]} />
          <meshBasicMaterial {...mat} wireframe />
        </mesh>
      </group>
      <group ref={rightLeg} position={[0.14, 0.55, 0]}>
        <mesh position={[0, -0.27, 0]}>
          <boxGeometry args={[0.14, 0.55, 0.14]} />
          <meshBasicMaterial {...mat} wireframe />
        </mesh>
      </group>
      <pointLight position={[0, 1.2, 0]} intensity={4} color="#01FFFF" distance={4} />
    </group>
  );
}
